<template>
  <div
    class="home"
    :class="{ 'home--expanded': isExpanded }"
  >
    <FollowElements />

    <HomeHeader
      :expanded="isExpanded"
      :show-menu="showMenuButton"
    />

    <div class="home__content">
      <HomeCategories />
      <HomePets />
      <HomePlaces />
      <HomeProducts />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { FollowElements, panePosition } from '@/components/PaneMain'
import { useDevice } from '@/composables/useDevice'
import HomeHeader from './components/HomeHeader.vue'
import HomeCategories from './components/HomeCategories.vue'
import HomePets from './components/HomePets.vue'
import HomePlaces from './components/HomePlaces.vue'
import HomeProducts from './components/HomeProducts.vue'

const { isMobileDevice } = useDevice()

// Шторка выдвинута на весь экран: показываем зелёную шапку (правый макет)
const isExpanded = computed(() => isMobileDevice.value && panePosition.value === 'top')

// В свёрнутом виде кнопка меню скрыта (как на макете), на десктопе шторки нет — показываем всегда
const showMenuButton = computed(() => isExpanded.value || !isMobileDevice.value)
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  background: #f3f4f8;

  &__content {
    display: grid;
    gap: 24px;
    padding: 20px 20px 40px;
  }
}

// в раскрытом виде шторка без скругления сверху, чтобы зелёная шапка шла до края
:global(.cupertino:has(.home--expanded)) {
  border-radius: 0 !important;
}

[theme="dark"] .home {
  background: #1b1b1b;
}
</style>
